<template>
    <div>
        <page-header :heading="pageHeader.title" />
        <div class="row">
            <div class="col">
                <div v-if="!itemsSelected">
                    <b-dropdown size="sm" variant="link" toggle-class="text-decoration-none" no-caret>
                        <template #button-content>
                            <span>View <i class="arrow down"></i></span>
                        </template>
                        <b-dropdown-item href="#" @click="() => view = 1">Card</b-dropdown-item>
                        <b-dropdown-item href="#" @click="() => view = 2">Table</b-dropdown-item>
                    </b-dropdown>

                    <b-dropdown size="sm" variant="link" toggle-class="text-decoration-none" no-caret>
                        <template #button-content>
                            <span>Order <i class="arrow down"></i></span>
                        </template>
                        <b-dropdown-item href="#" @click="() => order = 1">Submitted Date</b-dropdown-item>
                        <b-dropdown-item href="#" @click="() => order = 2">Document Approved Date</b-dropdown-item>
                    </b-dropdown>
                </div>
                <div v-else>
                    <b-dropdown size="sm" variant="link" toggle-class="text-decoration-none" no-caret>
                        <template #button-content>
                            <span>Status <i class="arrow down"></i></span>
                        </template>
                        <b-dropdown-item href="#" :disabled="!allSelectedItemsAuthorisable" @click="setStatuses(selectedItems,1000)">Authorised</b-dropdown-item>
                        <b-dropdown-item href="#" :disabled="!allSelectedItemsRejectable" @click="setStatuses(selectedItems,1001)">Rejected</b-dropdown-item>
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item href="#" :disabled="!allSelectedItemsPaidable" @click="setStatuses(selectedItems,1002)">Paid</b-dropdown-item>
                    </b-dropdown>
                    <b-modal id="progress-modal-1" hide-footer="true">
                        <b-progress :value="progressValue" :max="progressMax" show-value class="mb-3"></b-progress>
                    </b-modal>
                </div>
            </div>
            <div class="col col-auto">
                <button type="button" class="btn btn-outline-primary mr-1" @click="showFilters()" :disabled="itemsSelected"><i class="fas fa-filter"></i> Filter</button>
                <button type="button" class="btn btn-outline-primary mr-1" @click="showSearch()" :disabled="itemsSelected"><i class="fas fa-search"></i> Search</button>
                <button type="button" class="btn btn-outline-primary" @click="showExport()"><i class="fas fa-file-download"></i> Export</button>
            </div>
            <slidy-thing id="filter" ref="filter" width="617px" openOn="right" v-on:panel-close="filterPanelClose">
                <div class="container" :style="slidyThingContainerStyle2">
                    <b-form-group label="Status:" v-slot="{ ariaDescribedby }">
                        <b-form-checkbox-group id="filter-status" v-model="filters.status">
                            <b-form-checkbox :value="1000">Authorised</b-form-checkbox><br />
                            <b-form-checkbox :value="1001">Rejected</b-form-checkbox><br />
                            <b-form-checkbox :value="1003">Scheduled for Payment</b-form-checkbox><br />
                            <b-form-checkbox :value="1002">Paid</b-form-checkbox><br />
                            <b-form-checkbox :value="null">Not yet selected</b-form-checkbox>
                        </b-form-checkbox-group>
                    </b-form-group>
                    <div class="form-group">
                        <label for="filter-underwriter">Underwriter:</label>
                        <select class="form-control" id="filter-underwriter" v-model="filters.underwriter">
                            <option :value="null"></option>
                            <option v-for="(itm, idx) in underwriters" :value="itm">{{itm.name}}</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label for="filter-reseller">Reseller:</label>
                        <select class="form-control" id="filter-reseller" v-model="filters.reseller">
                            <option :value="null"></option>
                            <option v-for="(itm, idx) in resellers" :value="itm">{{itm.name}}</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label for="filter-created">Created:</label>
                        <select class="form-control" id="export-created" v-model="filters.created">
                            <option :value="null"></option>
                            <option v-for="(itm, idx) in dateRanges" :value="itm">{{itm.label}}</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label for="filter-created">Authorised:</label>
                        <select class="form-control" id="export-authorised" v-model="filters.authorised" :disabled="!showAuthorisedDateFilter">
                            <option :value="null"></option>
                            <option v-for="(itm, idx) in dateRanges" :value="itm">{{itm.label}}</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label for="filter-created">Rejected:</label>
                        <select class="form-control" id="export-rejected" v-model="filters.rejected" disabled>
                            <option :value="null"></option>
                            <option v-for="(itm, idx) in dateRanges" :value="itm">{{itm.label}}</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label for="filter-created">Paid:</label>
                        <select class="form-control" id="export-paid" v-model="filters.paid" disabled>
                            <option :value="null"></option>
                            <option v-for="(itm, idx) in dateRanges" :value="itm">{{itm.label}}</option>
                        </select>
                    </div>
                    <div class="mt-2">
                        <button type="button" class="btn btn-outline-primary mr-1" @click="clearFiltersClick()">Clear</button>
                        <!--<button type="button" class="btn btn-outline-primary" @click="applyFiltersClick()">Apply</button>-->
                    </div>
                </div>
            </slidy-thing>
            <slidy-thing id="search" ref="search" width="617px" openOn="right">
                <div class="container" :style="slidyThingContainerStyle2">
                    <div class="form-group">
                        <input type="text" class="form-control" id="search-criteria" v-model="searchText">
                    </div>
                    <div class="mt-2">
                        <button type="button" class="btn btn-outline-primary mr-1" @click="() => { searchText = null; }">Clear</button>
                        <!--<button type="button" class="btn btn-outline-primary" @click="searchButtonClicked = true">Search</button>-->
                    </div>
                </div>
            </slidy-thing>
            <slidy-thing id="export" ref="export" width="617px" openOn="right" v-on:panel-close="exportPanelClose">
                <div class="container" :style="slidyThingContainerStyle2">
                    <b-card no-body>
                        <b-tabs card v-model="exportTabIdx">
                            <b-tab title="New" active>
                                <b-form-group label="Status:" v-slot="{ ariaDescribedby }">
                                    <b-form-checkbox-group id="export-status" v-model="exportFilter.status">
                                        <b-form-checkbox value="1001">Rejected</b-form-checkbox><br/>
                                        <b-form-checkbox value="1000">Authorised</b-form-checkbox><br />
                                        <b-form-checkbox :value="1003">Scheduled for Payment</b-form-checkbox><br />
                                        <b-form-checkbox value="1002">Paid</b-form-checkbox>
                                    </b-form-checkbox-group>
                                </b-form-group>
                                <div class="form-group">
                                    <label for="export-underwriter">Underwriter:</label>
                                    <select class="form-control" id="export-underwriter" v-model="exportFilter.underwriter">
                                        <option :value="null"></option>
                                        <option v-for="(itm, idx) in underwriters" :value="itm">{{itm.name
                    }}</option>
                    </select>
</div>
                                <div class="form-group">
                                    <label for="export-reseller">Reseller:</label>
                                    <select class="form-control" id="export-reseller" v-model="exportFilter.reseller">
                                        <option :value="null"></option>
                                        <option v-for="(itm, idx) in resellers" :value="itm">{{itm.name}}</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label for="filter-created">Created:</label>
                                    <select class="form-control" id="export-created" v-model="exportFilter.created" disabled>
                                        <option :value="null"></option>
                                        <option v-for="(itm, idx) in dateRanges" :value="itm">{{itm.label}}</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label for="filter-created">Authorised:</label>
                                    <select class="form-control" id="export-authorised" v-model="exportFilter.authorised" disabled>
                                        <option :value="null"></option>
                                        <option v-for="(itm, idx) in dateRanges" :value="itm">{{itm.label}}</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label for="filter-created">Rejected:</label>
                                    <select class="form-control" id="export-rejected" v-model="exportFilter.rejected" disabled>
                                        <option :value="null"></option>
                                        <option v-for="(itm, idx) in dateRanges" :value="itm">{{itm.label}}</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label for="filter-created">Paid:</label>
                                    <select class="form-control" id="export-paid" v-model="exportFilter.paid" disabled>
                                        <option :value="null"></option>
                                        <option v-for="(itm, idx) in dateRanges" :value="itm">{{itm.label}}</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label for="export-filename">Filename:</label>
                                    <input type="text" class="form-control" id="export-filename" v-model="exportFilter.filename" @keyup="sanitiseFilename">
                                </div>
                                <button type="button" class="btn btn-outline-primary mt-2" @click="createExport">Export</button>
                            </b-tab>
                            <b-tab title="Previous">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th scope="col">Filename</th>
                                            <th scope="col">Requested</th>
                                            <th scope="col">Requested By</th>
                                            <th scope="col">Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(f, idx) in exportFilesOrdered" :key="'export_file_' + idx">
                                            <td>{{f.filename}}</td>
                                            <td>{{localeString(f.dateCreated)}}</td>
                                            <td>{{f.createdByName | truncate(10)}}</td>
                                            <td v-if="showExportFileDownloadLink(f)"><a href="javascript:void(0)" @click="handleExportClick(f.id, f.filename)">{{getExportFileStatus(f)}}</a></td>
                                            <td v-else>{{getExportFileStatus(f)}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <button type="button" class="btn btn-outline-primary mt-2" v-b-modal.modal-1>View more</button>
                                <b-modal id="modal-1" title="Exports" size="lg">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th scope="col">Filename</th>
                                                <th scope="col">Requested</th>
                                                <th scope="col">Requested By</th>
                                                <th scope="col">Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(f, idx) in exportFilesOrdered" :key="'export_file_' + idx">
                                                <td>{{f.filename}}</td>
                                                <td>{{localeString(f.dateCreated)}}</td>
                                                <td>{{f.createdByName}}</td>
                                                <td v-if="showExportFileDownloadLink(f)"><a href="javascript:void(0)" @click="handleExportClick(f.id, f.filename)">{{getExportFileStatus(f)}}</a></td>
                                                <td v-else>{{getExportFileStatus(f)}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </b-modal>
                            </b-tab>
                        </b-tabs>
                    </b-card>
                </div>
            </slidy-thing>
        </div>
        <hr />
        <div class="row">
            <div class="col" style="padding: 5px 5px 5px 25px; ">
                <h5 v-if="selectedItems && selectedItems.length > 0">
                    {{selectedItems.length}} payment item(s) of {{itemsFiltered.length}} selected [Filtered by status: {{statusFilterText}}]
                </h5>
                <h5 v-else>
                    {{itemsFiltered ? itemsFiltered.length : ''}} payment items [Filtered by status: {{statusFilterText}}]
                </h5>
                
            </div>
        </div>
        <hr />
        <div v-if="view == 1" class="scroller" style="min-width: 980px;">
            <b-list-group v-if="this.items && this.items.length > 0">
                <b-list-group-item v-for="(itm,idx) in itemsFiltered" :key="'itemsFiltered_' + idx" :disabled="isItemDisabled(itm)">
                    <div class="row" :key="'custPayment_' + idx">
                        <div class="col-1">
                            <b-form-checkbox :id="'cust-payment-check-' + itm.id" v-model="selectedItems" :value="itm" :disabled="itemSelectDisabled" />
                        </div>
                        <div class="col">
                            <h5>{{itm.claimReference}}</h5>
                            <div class="row">
                                <div class="col">
                                    <small>{{itm.underwriterName}} - {{itm.resellerName}}</small>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col" v-if="itm.relatedReference">
                                    <small>{{itm.relatedReference}} - Policy: {{itm.policyNumber}}</small>
                                </div>
                                <div class="col" v-else>
                                    <small>NO RELATED REFERENCE - Policy: {{itm.policyNumber}}</small>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <small>Policy Cover Dates: {{localeString(itm.policyCoverStartDate)}} - {{localeString(itm.policyCoverEndDate)}}</small>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <small>Claimant: {{itm.claimantTitle}} {{itm.claimantFirstname}} {{itm.claimantLastname}}</small>
                                </div>
                            </div>
                            <div v-if="itm.children && itm.children.length > 0">
                                <div v-for="(cld, cldIdx) in itm.children">
                                    <div class="row">
                                        <div class="col">
                                            <small>{{cld.gadgetMakeLabel}} - {{cld.gadgetModelLabel}}</small>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <small>IMEI / Serial: {{getIMEISerialNos(cld)}}</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div class="row">
                                    <div class="col">
                                        <small>{{itm.gadgetMakeLabel}} - {{itm.gadgetModelLabel}}</small>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <small>IMEI / Serial: {{getIMEISerialNos(itm)}}</small>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <small>Pipeline: <a href="#" @click="showPipelineResults(itm)">{{itm.pipelineLabel}}</a> ({{itm.pipelinePassed}}) <!--/ {{itm.pipelineRunDate}})--></small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="row">
                                <div class="col">
                                    <small>Rate Type: {{itm.policyRatingTypeName}}</small>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <span class="font-weight-bold">Cover Limit: {{getCoverLimit(itm)}}</span>
                                    <i :id="'cover-limit-info-' + idx" class="pointer pl-1 fas fa-info-circle" v-on:click.stop></i>
                                    <b-popover :target="'cover-limit-info-' + idx" triggers="hover focus">
                                        <template #title>
                                            Cover Limit(s)
                                        </template>
                                        <div class="row">
                                            <div class="col">
                                                <small>Rate Type: {{itm.policyRatingTypeName}}</small>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col">
                                                <small>Device Value: {{itm.gadgetValue}}</small>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col">
                                                <small>SAL: {{itm.policySAL}}</small>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col">
                                                <small>Cover Limit: {{itm.policyCoverLimit}}</small>
                                            </div>
                                        </div>
                                    </b-popover>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <small>Reimbursement Amount: ({{itm.reimbursementCurrency}}) {{itm.reimbursementAmount}} (Man)</small>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <small>VAT Registered: {{itm.vatRegistered}}</small>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="row mt-1">
                                <div class="col">
                                    <b-list-group v-if="itm.documentId">
                                        <b-list-group-item href="javascript:void(0)" @click="openDocument(itm)">
                                            <div class="row">
                                                <div class="col">
                                                    <i class="fas fa-file pr-1"></i> <small>{{itm.documentOriginalFilename}}</small>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col">
                                                    <div class="row">
                                                        <div class="col">
                                                            <small>Status: {{itm.documentStatusLabel}}</small> <i :id="'doc-status-info-' + idx" class="pointer pl-1 fas fa-info-circle" v-on:click.stop></i>
                                                        </div>
                                                    </div>
                                                    <div v-if="itm.documentStatusCreatedByUser" class="row">
                                                        <div class="col">
                                                            <small>Approved by: {{itm.documentStatusCreatedByUser}}</small>
                                                        </div>
                                                    </div>
                                                    <b-popover :target="'doc-status-info-' + idx" triggers="hover focus">
                                                        <template #title>
                                                            Document Status
                                                        </template>
                                                        <p><small><strong>APPROVED_APPROVAL_LIMIT_CHECK</strong> - Customer entered amount checked against Approval limits</small></p>
                                                        <p><small><strong>APPROVED_AUTO_DOCUMENT_CHECK</strong> - Document values checked (OCR)</small></p>
                                                        <p><small><strong>APPROVED_MANUAL</strong> - Claim agent approved manually</small></p>
                                                    </b-popover>
                                                </div>
                                            </div>
                                        </b-list-group-item>
                                    </b-list-group>

                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="row">
                                <div class="col">
                                    <copy-to-clipboard :textToCopy="itm.bankName">
                                        <small>{{itm.bankName}}</small>
                                    </copy-to-clipboard>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <copy-to-clipboard :textToCopy="itm.accountName"><small>{{itm.accountName}}</small></copy-to-clipboard>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <copy-to-clipboard :textToCopy="itm.accountNumber"><small>{{itm.accountNumber}}</small></copy-to-clipboard>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <copy-to-clipboard :textToCopy="itm.accountSortcode"><small>{{itm.accountSortcode}}</small></copy-to-clipboard>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col border-top mt-2">
                                    <small>Claim Payment (net): ({{itm.claimPaymentCurrencyCode}}) {{formatNumber(itm.claimPaymentNet)}}</small>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <small>Claim Payment (tax): ({{itm.claimPaymentCurrencyCode}}) {{formatNumber(itm.claimPaymentTax)}}</small>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col ">
                                    <small>Claim Payment (gross): ({{itm.claimPaymentCurrencyCode}}) {{formatNumber(itm.claimPaymentGross)}}</small>
                                </div>
                            </div>
                            <div class="row" v-if="itm.claimPaymentAuthorisedBy">
                                <div class="col ">
                                    <small>Authorised by: {{itm.claimPaymentAuthorisedUser}}</small>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <small>Excess: ({{getExcessCurrencyCode(itm)}}) {{formatNumber(getExcessAmount(itm))}}</small>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <small>Excess waived: {{itm.isExcessWaived}}</small>
                                </div>
                            </div>
                            <div class="col">
                                <div class="row pt-1" v-if="excessPaid(itm)">
                                    <small>Excess Payment: ({{itm.cardPaymentCurrencyCode}}) {{formatNumber(itm.cardPaymentAmount)}}</small> <i :id="'xs-payment-info-' + idx" class="pointer pl-1 fas fa-info-circle"></i>
                                    <b-popover :target="'xs-payment-info-' + idx" triggers="hover focus">
                                        <template #title>
                                            Payment Details
                                        </template>
                                        <p><small>Payment Date: {{localeString(itm.cardPaymentDate)}}</small></p>
                                        <p><small>Transaction Id: {{itm.cardPaymentTransactionId}}</small></p>
                                    </b-popover>
                                </div>
                                <div v-else class="row pt-1">
                                    <small>Excess Payment: (---) 0.00</small>
                                </div>
                            </div>
                            <div class="row ">
                                <div class="col">
                                    <copy-to-clipboard :textToCopy="formatNumber(getPaymentAmount(itm))">
                                        <span class="text-small font-weight-bold">Amount to Pay: (GBP) {{formatNumber(getPaymentAmount(itm))}}</span>
                                    </copy-to-clipboard>
                                </div>
                            </div>
                        </div>
                        <div class="col-1 border-left">
                            <div class="row" style="height: 50%">
                                <div class="col">
                                    <b-dropdown size="sm" variant="link" toggle-class="text-decoration-none" no-caret>
                                        <template #button-content>
                                            <span>{{getStatusLabel(itm)}} <i class="arrow down"></i></span>
                                        </template>
                                        <b-dropdown-item href="#" v-if="isResetEnabled(itm)" :disabled="!isResetEnabled(itm)" @click="setStatus(itm,999)">RESET!</b-dropdown-item>
                                        <b-dropdown-item href="#" :disabled="!isAuthorisedEnabled(itm)" @click="setStatus(itm,1000)">Authorised</b-dropdown-item>
                                        <b-dropdown-item href="#" :disabled="!isRejectedEnabled(itm)" @click="statusRejectedShow(itm,1001)">Rejected</b-dropdown-item>
                                        <b-dropdown-item href="#" :disabled="!isSchedulePaymentEnabled(itm)" @click="statusSchedulePaymentShow(itm,1003)">Scheduled</b-dropdown-item>
                                        <b-dropdown-divider></b-dropdown-divider>
                                        <b-dropdown-item href="#" :disabled="!isPaidEnabled(itm)" @click="statusPaidShow(itm,1002)">Paid</b-dropdown-item>
                                    </b-dropdown>
                                </div>
                            </div>
                            <div class="row" style="height: 50%">
                                <div class="col align-self-end">
                                    <span class="align-bottom"><button type="button" class="btn btn-outline-primary btn-sm" :disabled="!itm.customerPaymentStatusId" @click="showTimelinePanel(itm.id)"><i class="fa fa-clock"></i> Timeline</button></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-list-group-item>
            </b-list-group>
            <slidy-thing id="timeline" ref="timeline" width="617px" openOn="right" v-on:panel-close="timelinePanelClose">
                <div class="container" :style="slidyThingContainerStyle2">
                    <div v-if="timelineLoading" class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                    <fred v-model="timelineItems"></fred>
                </div>
            </slidy-thing>
            <b-modal id="modal-set-schedule-payment" title="Schedule for Payment" v-model="showSchedulePaymentModal"
                     @ok="statusSchedulePaymentOk" @cancel="statusSchedulePaymentCancel">
                <div class="row mb-1" v-if="selectedItem">
                    <div class="col">
                        Amount Paid: (GBP) {{formatNumber(getPaymentAmount(selectedItem))}}
                    </div>
                </div>
                <div class="form-group">
                    <label for="payment-ref">Payment Ref:</label>
                    <input type="text" class="form-control" id="payment-ref" v-model="paymentRef">
                </div>
                <div class="form-group">
                    <label for="payment-notes">Notes:</label>
                    <textarea class="form-control" id="payment-notes" name="payment-notes" rows="4" cols="50" v-model="paymentNotes"></textarea>
                </div>
            </b-modal>
            <b-modal id="modal-set-paid" title="Set as paid" v-model="showPaidModal" @ok="statusPaidOk" @cancel="statusPaidCancel">
                <div class="row mb-1" v-if="selectedItem">
                    <div class="col">
                        Amount Paid: (GBP) {{formatNumber(getPaymentAmount(selectedItem))}}
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <b-form-checkbox id="sendPaymentEmail"
                                v-model="sendPaymentEmail"
                                name="sendPaymentEmail"
                                :value="true"
                                :unchecked-value="false">
                            Send the Claim Payment email
                        </b-form-checkbox>
                    </div>
                </div>
            </b-modal>
            <b-modal id="modal-set-rejected" title="Set as rejected" v-model="showRejectedModal" @ok="statusRejectedOk" @cancel="statusRejectedCancel">
                <div class="form-group">
                    <label for="rejected-reason">Reason:</label>
                    <select name="rejected-reason" id="rejected-reason" class="form-control" v-model="rejectedReason">
                        <option :value="null"></option>
                        <option v-for="(itm, idx) in rejectReasons" :key="'rejectReason_' + idx" :value="itm.id">{{itm.label}}</option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="payment-notes">Notes:</label>
                    <textarea class="form-control" id="payment-notes" name="payment-notes" rows="4" cols="50" v-model="paymentNotes"></textarea>
                </div>
            </b-modal>
            <slidy-thing id="viewValidationResults" ref="viewValidationResults" width="617px" openOn="right">
                <div class="container" :style="slidyThingContainerStyle2">
                    <div class="mb-3">
                        <i class="far fa-circle" style="color: darkorange"></i> Rule not run
                        <i class="far fa-check-circle" style="color: green"></i> Rule passed
                        <i class="far fa-times-circle" style="color: red"></i> Rule failed
                    </div>
                    <hr />
                    <div class="row mb-2" v-for="(rule, index) in selectedPipelineRules">
                        <div class="col">
                            <b-list-group>
                                <b-list-group-item>
                                    <div class="row">
                                        <div class="col-2">
                                            <i v-if="rule.StatusText == 'NOT_RUN'" class="far fa-circle fa-2x" style="color: darkorange"></i>
                                            <i v-if="rule.StatusText == 'PASSED'" class="far fa-check-circle fa-2x" style="color: green"></i>
                                            <i v-if="rule.StatusText == 'FAILED'" class="far fa-times-circle fa-2x" style="color: red"></i>
                                        </div>
                                        <div class="col">
                                            <h6>{{rule.RuleName.trim()}}</h6>
                                        </div>
                                    </div>
                                </b-list-group-item>
                            </b-list-group>

                        </div>
                    </div>
                </div>
            </slidy-thing>

        </div>
        <div v-if="view == 2" class="scroller">
            <table class="table">
                <thead>
                    <tr>
                        <th scope="col"><b-form-checkbox id="checkbox-1" :disabled="itemSelectDisabled" /></th>
                        <th scope="col">Claim Reference</th>
                        <th scope="col">Policy Number</th>
                        <th scope="col">Underwriter</th>
                        <th scope="col">Reseller</th>
                        <th scope="col">Policy Cover Start</th>
                        <th scope="col">Policy Cover End</th>
                        <th scope="col">Gadget</th>
                        <th scope="col">Document</th>
                        <th scope="col">Reimbursement (Man)</th>
                        <th scope="col">Bank Name</th>
                        <th scope="col">Account Name</th>
                        <th scope="col">Account Number</th>
                        <th scope="col">Sortcode</th>
                        <th scope="col">Excess</th>
                        <th scope="col">Excess Payment</th>
                        <th scope="col">Amount to Pay</th>
                        <th scope="col">Validation Pipeline</th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(itm,idx) in itemsFiltered" :key="'itemsFiltered_' + idx">
                        <th scope="row"><b-form-checkbox id="checkbox-1" :disabled="itemSelectDisabled" /></th>
                        <td>{{itm.claimReference}}</td>
                        <td>{{itm.policyNumber}}</td>
                        <td>{{itm.underwriterName}}</td>
                        <td>{{itm.resellerName}}</td>
                        <td>{{itm.policyCoverStartDate}}</td>
                        <td>{{itm.policyCoverEndDate}}</td>
                        <td>{{itm.gadgetMakeLabel}} - {{itm.gadgetModelLabel}}</td>
                        <td><a href="">{{itm.documentOriginalFilename}}</a></td>
                        <td>({{itm.reimbursementCurrency}}) {{itm.reimbursementAmount}}</td>
                        <td>{{itm.bankName}}</td>
                        <td>{{itm.accountName}}</td>
                        <td>{{itm.accountNumber}}</td>
                        <td>{{itm.accountSortcode}}</td>
                        <td>({{getExcessCurrencyCode(itm)}}) {{getExcessAmount(itm)}}</td>
                        <td><div v-if="excessPaid(itm)">({{itm.cardPaymentCurrencyCode}}) {{itm.cardPaymentAmount}}</div></td>
                        <td>(GBP) {{getPaymentAmount(itm)}}</td>
                        <td>{{itm.pipelineLabel}} ({{itm.pipelinePassed}})</td>
                        <td>
                            <b-dropdown size="sm" variant="link" toggle-class="text-decoration-none" no-caret>
                                <template #button-content>
                                    <span>Status <i class="arrow down"></i></span>
                                </template>
                                <b-dropdown-item href="#">Authorised</b-dropdown-item>
                                <b-dropdown-item href="#">Rejected</b-dropdown-item>
                                <b-dropdown-item href="#">Paid</b-dropdown-item>
                            </b-dropdown>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import PageHeader from '@/components/PageHeader.vue'
    import SlidyThing from "@/components/SlidyThing.vue";
    import CopyToClipboard from "@/components/CopyToClipboardV2.vue"
    import fred from "@/components/CustPaymentStatusHistory.vue"

    import { mapActions, mapGetters } from 'vuex'

    import axios from 'axios'

    const orderBySubmittedeDateASC = (obj1, obj2) => {
        return new Date(obj1.dateClaimSubmitted) - new Date(obj2.dateClaimSubmitted)
    }

    const orderBySubmittedeDateDESC = (obj1, obj2) => {
        return new Date(obj2.dateClaimSubmitted) - new Date(obj1.dateClaimSubmitted)
    }

    const orderByApprovalDateASC = (obj1, obj2) => {
        return new Date(obj1.dateDocumentApproved) - new Date(obj2.dateDocumentApproved)
    }

    const orderByApprovalDateDESC = (obj1, obj2) => {
        return new Date(obj2.dateDocumentApproved) - new Date(obj1.dateDocumentApproved)
    }

    const orderByCreatedDateDESC = (obj1, obj2) => {
        return new Date(obj2.dateCreated) - new Date(obj1.dateCreated)
    }

    const getFilterDates = (obj) => {
        console.log('-o: ', obj)
        const today = new Date()
        const dd = String(today.getDate()).padStart(2, '0')
        const mm = String(today.getMonth()+1).padStart(2, '0')
        const yyyy = String(today.getFullYear())

        switch (obj.id) {
            case 1:
                return { from: yyyy + '-' + mm + '-' + dd, to: yyyy + '-' + mm + '-' + dd }
                break
            case 2:
                const sevenDaysAgo = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000) 
                const dd2 = String(sevenDaysAgo.getDate()).padStart(2, '0')
                const mm2 = String(sevenDaysAgo.getMonth() + 1).padStart(2, '0')
                const yyyy2 = String(sevenDaysAgo.getFullYear())
                return { from: yyyy2 + '-' + mm2 + '-' + dd2, to: yyyy + '-' + mm + '-' + dd }
                break
            case 3:
                const twentyEightDaysAgo = new Date(Date.now() - 28 * 24 * 60 * 60 * 1000)
                const dd3 = String(twentyEightDaysAgo.getDate()).padStart(2, '0')
                const mm3 = String(twentyEightDaysAgo.getMonth() + 1).padStart(2, '0')
                const yyyy3 = String(twentyEightDaysAgo.getFullYear())
                return { from: yyyy3 + '-' + mm3 + '-' + dd3, to: yyyy + '-' + mm + '-' + dd }
                break
        }
    }

    export default {
        name: 'CustomerPaymentsList',
        components: {
            PageHeader,
            SlidyThing,
            CopyToClipboard,
            fred
        },
        data: () => {
            return {
                pageHeader: {
                    title: 'Customer Payments',
                },
                view: 1, // 1: card 2: table
                order: 1, // 1: submitted date 2: doc approval date
                filters: {
                    status: [null],
                    underwriter: null,
                    reseller: null,
                    created: null,
                    authorised: null,
                    rejected: null,
                    paid: null
                },
                applyFilters: true,
                searchButtonClicked: true,
                searchText: null,
                exportFilter: {
                    status: [1000],
                    underwriter: null,
                    reseller: null,
                    created: null,
                    authorised: null,
                    rejected: null,
                    paid: null,
                    filename: null
                },
                childWindows: {},

                showPaidModal: false,
                showSchedulePaymentModal: false,
                paymentRef: null,
                paymentNotes: null,
                showRejectedModal: false,
                rejectedReason: null,
                rejectedNotes: null,
                selectedItem: null,
                selectedItems: [],

                exportTabIdx: 1,

                exportFileTimerId: null,

                progressMax: 0,
                progressValue: 0,

                timelineLoading: false,
                timelineItems: [],
                sendPaymentEmail: true,
                itemSelectDisabled: false
            }
        },
        async beforeMount() {
            //await this.getItems()
            await this.getItems()
            await this.getExportFiles()
            await this.loadRejectReasons()
        },
        async mounted() {
            this.exportFileTimerId = window.setInterval(() => {
                //console.log('Call getExportFiles!')
                this.getExportFiles()
            }, 60000)
        },
        watch: {
            exportTabIdx(val) {
                if (val === 0 && (this.exportFilter.filename === null || this.exportFilter.filename.length === 0)) {
                    this.exportFilter.filename = this.quickFilename
                }
            }
        },
        computed: {
            ...mapGetters({
                items: 'custPayments/getItems',
                exportFiles: 'custPayments/getExportFiles',
                pipelineHistoryItems: 'custPayments/getPipelineHistoryItems',
                rejectReasons: 'custPayments/getRejectReasons'
            }),
            getFilterCreatedDate() {
                if (this.filters.created) {
                    let { created } = this.filters
                    return getFilterDates(created)
                }
                else
                    return null
            },
            getFilterAuthorisedDate() {
                if (this.filters.authorised) {
                    let { authorised } = this.filters
                    return getFilterDates(authorised)
                }
                else
                    return null
            },
            showAuthorisedDateFilter() {
                const show = this.filters.status.includes(1000) || this.filters.status.includes(1002) || this.filters.status.includes(1003)

                if (show == false)
                    this.filters.authorised = null

                return show
            },
            applySearch() {
                if (this.searchButtonClicked == true) {
                    this.searchButtonClicked == false
                    return this.searchText != null  && this.searchText != ''
                }
                return false
            },
            itemsFiltered() {

                var items = []

                if (this.applyFilters) {
                    items = this.items.filter(itm =>
                        (this.filters.status && this.filters.status.length > 0 ? this.filters.status.includes(itm.customerPaymentStatusId) : true) &&
                        (this.filters.underwriter != null ? itm.underwriterId == this.filters.underwriter.id : true) &&
                        (this.filters.reseller != null ? itm.resellerId == this.filters.reseller.id : true))
                    if (this.filters.created) {
                        items = items.filter(itm => {
                            const itemDate = new Date(itm.dateCreated).setHours(0, 0, 0, 0)
                            const startDate = new Date(this.getFilterCreatedDate.from).setHours(0, 0, 0, 0)
                            const endDate = new Date(this.getFilterCreatedDate.to).setHours(0, 0, 0, 0)
                            return itemDate >= startDate && itemDate <= endDate
                        })
                    }
                    if (this.filters.authorised) {
                        items = items.filter(itm => {
                            if (itm.dateAuthorised) {
                                const itemDate = new Date(itm.dateAuthorised).setHours(0, 0, 0, 0)
                                const startDate = new Date(this.getFilterAuthorisedDate.from).setHours(0, 0, 0, 0)
                                const endDate = new Date(this.getFilterAuthorisedDate.to).setHours(0, 0, 0, 0)
                                console.log('-itemDate: ', itemDate)
                                console.log('-startDate: ', startDate)
                                console.log('-endDate: ', endDate)
                                return itemDate >= startDate && itemDate <= endDate
                            } else {
                                return false
                            }
                        })
                    }
                } else {
                    items = this.items
                }

                if (items && items.length > 0) {

                    if (this.applySearch) {
                        items = this.items.filter(itm =>
                            itm.claimReference.includes(this.searchText) ||
                            (itm.relatedReference && itm.relatedReference.includes(this.searchText)))
                    }

                    if (this.order === 2)
                        return items.sort(orderByApprovalDateASC)

                    return items.sort(orderBySubmittedeDateASC)
                } else
                {
                    return items
                }
                
            },
            statusFilterText() {
                let statusesText = ''
                if (this.filters && this.filters.status) {
                    let { status } = this.filters
                    if (status.includes(null)) {
                        statusesText += 'Not yet selected'
                    }
                    if (status.includes(1001)) {
                        if (statusesText.length > 0) {
                            statusesText += ', '
                        }
                        statusesText += 'Rejected'
                    }
                    if (status.includes(1000)) {
                        if (statusesText.length > 0) {
                            statusesText += ', '
                        }
                        statusesText += 'Authorised'
                    }
                    if (status.includes(1003)) {
                        if (statusesText.length > 0) {
                            statusesText += ', '
                        }
                        statusesText += 'Schedule for Payment'
                    }
                    if (status.includes(1002)) {
                        if (statusesText.length > 0) {
                            statusesText += ', '
                        }
                        statusesText += 'Paid'
                    }
                }
                return statusesText
            },
            exportFilesOrdered() {
                if (this.exportFiles) {
                    return this.exportFiles.sort(orderByCreatedDateDESC)
                }

                return []
            },
            slidyThingContainerStyle2() {
                return {
                    "overflow-y": "auto",
                    "max-height": "100%",
                    "max-width": '600px',
                    "min-width": '600px'
                }
            },
            underwriters() {
                if (this.items && this.items.length > 0) {
                    var underwriters = this.items.reduce(function (filtered, option) {
                        if (option.underwriterId && option.underwriterName) {
                            var idx = filtered.findIndex(function (object) { return object.id === option.underwriterId });
                            if (idx === -1) {
                                var underwriter = { id: option.underwriterId, name: option.underwriterName }
                                filtered.push(underwriter);
                            }
                        }
                        return filtered;
                    }, []);
                    return underwriters;
                }

                return [];
            },
            resellers() {
                if (this.items && this.items.length > 0) {
                    var resellers = this.items.reduce(function (filtered, option) {
                        if (option.resellerId && option.resellerName) {
                            var idx = filtered.findIndex(function (object) { return object.id === option.resellerId });
                            if (idx === -1) {
                                var reseller = { id: option.resellerId, name: option.resellerName }
                                filtered.push(reseller);
                            }
                        }
                        return filtered;
                    }, []);
                    return resellers;
                }

                return [];
            },
            dateRanges() {
                return [
                    {
                        id: 1,
                        label: 'Today'
                    },
                    {
                        id: 2,
                        label: 'Last 7 days'
                    },
                    {
                        id: 3,
                        label: 'Last 4 weeks'
                    },
                    {
                        id: 4,
                        label: 'Custom'
                    }
                ]
            },
            quickFilename() {
                var now = new Date().getTime();
                return "export_" + now;
            },
            selectedPipelineRules() {
                const orderByRunDateDESC = (obj1, obj2) => {
                    return new Date(obj2.runDate) - new Date(obj1.runDate)
                }

                if (this.pipelineHistoryItems && Array.isArray(this.pipelineHistoryItems)) {
                    var items = this.pipelineHistoryItems.sort(orderByRunDateDESC)
                    if (items && items.length > 0)
                        var json = items[0].result
                        if (json)
                            return JSON.parse(json)
                }
                return []
            },
            itemsSelected() {
                return this.selectedItems && this.selectedItems.length > 0
            },
            allSelectedItemsAuthorisable() {
                if (this.selectedItems && this.selectedItems.length > 0) {
                    return this.selectedItems.every(i => i.customerPaymentStatusId == null)
                }
                return false
            },
            allSelectedItemsRejectable() {
                if (this.selectedItems && this.selectedItems.length > 0) {
                    return this.selectedItems.every(i => i.customerPaymentStatusId == null)
                }
                return false
            },
            allSelectedItemsPaidable() {
                if (this.selectedItems && this.selectedItems.length > 0) {
                    return this.selectedItems.every(i => i.customerPaymentStatusId == 1003)
                }
                return false
            }
        },
        methods: {
            ...mapActions({
                getItems: 'custPayments/getItems',
                getItemsRemote: 'custPayments/getItemsRemote',
                setItemStatus: 'custPayments/setStatus',
                getPipelineRunHistory: 'custPayments/getPipelineRunHistory',
                resetPipelineRunHistory: 'custPayments/resetPipelineRunHistory',
                fetchAttachmentsForClaim: 'messageStore/fetchAttachmentsForClaim',
                fetchAttachmentDocumentTypes: 'messageStore/fetchDocumentTypes',
                setDocumentTypeForAttachment: 'messageStore/setDocumentTypeForAttachment',
                getExportFiles: 'custPayments/getExportFiles',
                getExportRows: 'custPayments/getExportRows',
                scheduleExport: 'custPayments/scheduleExport',
                loadRejectReasons: 'custPayments/getRejectReasons',
                getStatusHistory: 'custPayments/getStatusHistory'
            }),
            getExcessCurrencyCode(itm) {
                if (itm) {
                    if (itm.claimExcessCurrencyCode && itm.claimExcessCurrencyCode.length > 0 && itm.claimExcessAmount) {
                        return itm.claimExcessCurrencyCode
                    } else {
                        return itm.gadgetExcessCurrencyCode
                    }
                }
            },
            getExcessAmount(itm) {
                if (itm) {
                    if (itm.claimExcessCurrencyCode && itm.claimExcessCurrencyCode.length > 0 && itm.claimExcessAmount) {
                        return itm.claimExcessAmount
                    } else {
                        return itm.gadgetExcessAmount
                    }
                }
            },
            excessPaid(itm) {
                return itm.cardPaymentCurrencyCode && itm.cardPaymentAmount && itm.cardPaymentAmount > 0
            },
            getPaymentAmount(itm) {
                let amount = null
                let coverLimit = this.getCoverLimit(itm)
                if (this.excessPaid(itm)) {
                    amount = itm.claimPaymentGross /*+ itm.cardPaymentAmount*/
                } else {
                    amount = itm.claimPaymentGross - this.getExcessAmount(itm)
                }

                if (coverLimit < amount)
                    return coverLimit

                return amount
            },
            getIMEISerialNos(itm) {
                if (itm) {
                    var imeiSerial = ''
                    if (itm.imeiNo && itm.imeiNo.length > 0) {
                        imeiSerial = itm.imeiNo
                    }
                    if (itm.serialNo && itm.serialNo.length > 0) {
                        if (imeiSerial.length > 0) {
                            imeiSerial += ' / '
                        }
                        imeiSerial += itm.serialNo
                    }
                    return imeiSerial
                }
                return ''
            },
            async showPipelineResults(itm) {
                if (this.$refs["viewValidationResults"])
                    this.$refs["viewValidationResults"].showPanel();

                await this.getPipelineRunHistory({ relatedId1: itm.claimId, relatedId2: itm.gadgetId})
            },
            pipelineResultsPanelClose(ev) {
                this.resetPipelineRunHistory()
            },
            showFilters() {
                if (this.$refs["filter"])
                    this.$refs["filter"].showPanel();
            },
            filterPanelClose(ev) {
                //this.initFilters()
            },
            clearFiltersClick() {
                this.initFilters()
                this.applyFilters = false
            },
            applyFiltersClick() {
                this.applyFilters = true
            },
            showSearch() {
                if (this.$refs["search"])
                    this.$refs["search"].showPanel();
            },
            showExport() {
                if (this.$refs["export"]) {
                    this.$refs["export"].showPanel();
                    this.exportTabIdx = 0
                }
            },
            exportPanelClose(ev) {
                this.exportFilter = {
                    status: [1000],
                    underwriter: null,
                    reseller: null,
                    created: null,
                    authorised: null,
                    rejected: null,
                    paid: null,
                    filename: null
                }
                this.exportTabIdx = 1
            },
            async createExport() {
                if (this.exportFilter) {
                    var payload = {
                        statusIds: this.exportFilter.status,
                        underwriterId: this.exportFilter.underwriter ? this.exportFilter.underwriter.id : null,
                        resellerId: this.exportFilter.reseller ? this.exportFilter.reseller.id : null,
                        filename: this.exportFilter.filename
                    }
                    console.log('-exportFilters: ', payload)

                    try {
                        var response = await this.scheduleExport(payload)
                        if (response && response.data) {
                            this.exportFilter = {
                                status: [1000],
                                underwriter: null,
                                reseller: null,
                                created: null,
                                authorised: null,
                                rejected: null,
                                paid: null,
                                filename: null
                            }
                            this.exportTabIdx = 1
                        }
                    } catch (err) {
                        // TODO
                    }

                    console.log('-exportFilters response: ', response)
                }
            },
            showTimelinePanel(id) {
                this.timelineItems = [];
                console.log("-id: ", id)
                this.timelineLoading = true
                if (this.$refs["timeline"])
                    this.$refs["timeline"].showPanel();
                this.getStatusHistory({ id })
                    .then(response => {
                        console.log(response)
                        this.timelineItems = response.data
                    })
                    .finally(() => {
                        this.timelineLoading = false
                    })

            },
            timelinePanelClose(ev) {
                this.timelineLoading = false
            },
            getStatusLabel(itm) {
                //console.log('-i: ', itm)
                if (itm) {
                    if (itm.customerPaymentStatusLabel && itm.customerPaymentStatusLabel.length > 0) {
                        return itm.customerPaymentStatusLabel.split(' ')[0]
                    }
                }
                return 'Status'
            },
            isAuthorisedEnabled(itm) {
                if (itm) {
                    if (itm.customerPaymentStatusId) {
                        return false
                    } else {
                        return true
                    }
                }
            },
            isRejectedEnabled(itm) {
                if (itm) {
                    if (itm.customerPaymentStatusId && itm.customerPaymentStatusId == 1001) {
                        return false
                    } else {
                        return true
                    }
                }
            },
            isPaidEnabled(itm) {
                if (itm) {
                    if (itm.customerPaymentStatusId ) {
                        if (itm.customerPaymentStatusId == 1003) {
                            return true
                        }
                    }
                }
                return false
            },
            isSchedulePaymentEnabled(itm) {
                if (itm) {
                    if (itm.customerPaymentStatusId) {
                        if (itm.customerPaymentStatusId == 1000) {
                            return true
                        }
                    }
                }
                return false
            },
            isResetEnabled(itm) {
                if (itm) {
                    if (itm.customerPaymentStatusId) {
                        if (itm.customerPaymentStatusId == 1001) {
                            return true
                        }
                    }
                }
                return false
            },
            async openDocument(itm) {
                if (this.childWindows['document_' + itm.documentInternalFilename] == null ||
                    this.childWindows['document_' + itm.documentInternalFilename].closed) {

                    let response = await axios.get(window.location.origin + '/api/admin/v1/custpayments/key')

                    var url = window.location.origin + '/api/admin/v1/custpayments/download/' + itm.documentId + '/' + response.data
                    var filename = itm.documentOriginalFilename
                    var ext = filename.split('.').pop();

                    if (ext.toLowerCase() == 'pdf') {
                        this.childWindows['document_' + itm.documentInternalFilename] = window
                            .open(`/viewers/pdfViewer.html?url=${url}&filename=${filename}`, itm.claimReference, "width=500,height=700");
                    } else if (["jpg", "jpeg", "png"].indexOf(ext.toLowerCase()) >= 0) {
                        this.childWindows['document_' + itm.documentInternalFilename] = window
                            .open(`/viewers/imgViewer.html?url=${url}&filename=${filename}`, itm.claimReference, "width=500,height=700");
                    }
                } else {
                    this.childWindows['document_' + itm.documentInternalFilename].focus()
                }
            },
            initFilters() {
                this.filters = {
                    status: [null],
                    underwriter: null,
                    reseller: null,
                    created: null,
                    authorised: null,
                    rejected: null,
                    paid: null
                }
            },
            sanitiseFilename() {
                if (typeof this.exportFilter.filename === 'string' || this.exportFilter.filename instanceof String)
                    this.exportFilter.filename = (this.exportFilter.filename.replace(/[ &\/\\#,+()$~%.'":*?<>{}[];]/g, ''))
                else
                    this.exportFilter.filename = null
            },
            statusSchedulePaymentShow(itm, statusId) {
                this.selectedItem = itm
                this.showSchedulePaymentModal = true
            },
            statusPaidShow(itm, statusId) {
                this.selectedItem = itm
                this.showPaidModal = true
            },
            statusRejectedShow(itm, statusId) {
                this.selectedItem = itm
                this.showRejectedModal = true
            },
            async statusPaidOk(bvModalEvent) {
                bvModalEvent.preventDefault()
                //console.log('statusPaidOk: ', this.selectedItem)

                const payload = {
                    id: this.selectedItem.id,
                    statusId: 1002,
                    rv: this.selectedItem.rv,
                    sendPaymentEmail: this.sendPaymentEmail
                }

                var response = await this.setItemStatus(payload)
                //console.log('-r: ', response)
                this.showPaidModal = false

                this.paymentRef = null
                this.paymentNotes = null
                this.selectedItem = null
                this.sendPaymentEmail = true
            },
            async statusSchedulePaymentOk(bvModalEvent) {
                bvModalEvent.preventDefault()
                //console.log('statusSchedulePaymentOk: ', this.selectedItem)

                const payload = {
                    id: this.selectedItem.id,
                    statusId: 1003,
                    rv: this.selectedItem.rv,
                    paymentRef: this.paymentRef,
                    paymentNotes: this.paymentNotes
                }

                var response = await this.setItemStatus(payload)
                //console.log('-r: ', response)
                this.showSchedulePaymentModal = false

                this.paymentRef = null
                this.paymentNotes = null
                this.selectedItem = null
            },
            statusPaidCancel(bvModalEvent) {
                console.log('statusPaidCancel: ', this.selectedItem)
                this.selectedItem = null
            },
            statusSchedulePaymentCancel(bvModalEvent) {
                //console.log('statusSchedulePaymentCancel: ', this.selectedItem)
                this.selectedItem = null
            },
            async statusRejectedOk(bvModalEvent) {
                bvModalEvent.preventDefault()
                //console.log('statusRejectedOk: ', this.selectedItem)

                const payload = {
                    id: this.selectedItem.id,
                    statusId: 1001,
                    rv: this.selectedItem.rv,
                    rejectedReason: this.rejectedReason,
                    rejectedNotes: this.rejectedNotes
                }
                console.log('-p: ', payload)
                var response = await this.setItemStatus(payload)
                console.log('-r: ', response)
                this.showRejectedModal = false

                this.rejectedReason = null
                this.rejectedNotes = null
                this.selectedItem = null
            },
            statusRejectedCancel(bvModalEvent) {
                //console.log('statusRejectedCancel: ', this.selectedItem)
                this.selectedItem = null
            },
            setStatus(itm, statusId) {
                //console.log('itm: ', itm)
                this.$bvModal.msgBoxConfirm('Please confirm that you want to set the status')
                    .then(value => {
                        if (value === true) {
                            const payload = {
                                id: itm.id,
                                statusId,
                                rv: itm.rv
                            }

                            this.setItemStatus(payload)
                                .then(response => {

                                })
                                .catch(err => { /* DO NOTHING */ })
                                .finally(() => this.selectedItems = [])
                        }
                    })
                    .catch(err => {
                        // An error occurred
                    })
            },
            setStatuses(itms, statusId) {

                this.$bvModal.msgBoxConfirm(`Please confirm that you want to set the status of ${itms.length} items`)
                    .then(value => {
                        if (value === true) {
                            this.progressValue = 0
                            this.progressMax = itms.length
                            this.$bvModal.show('progress-modal-1')
                            itms.forEach(itm => {

                                const payload = {
                                    id: itm.id,
                                    statusId,
                                    sendPaymentEmail: statusId == 1002 ? true : false,
                                    rv: itm.rv
                                }

                                this.setItemStatus(payload)
                                    .then(response => {
                                        console.log(response)
                                        this.progressValue += 1
                                    })
                                    .catch(err => { /* DO NOTHING */ })
                                    .finally(() => {
                                        this.$bvModal.hide('progress-modal-1')
                                        //this.selectedItems = []
                                    })

                            });
                            this.selectedItems = []
                        }
                    })
                    .catch(err => {
                        // An error occurred
                    })
            },
            getExportFileStatus(file) {
                const DEFAULT_STATUS = 'Scheduled'

                if (file) {
                    if (file.dateRunFinish) {
                        return 'Download'
                    } else if (file.dateRunStart) {
                        return 'Running'
                    } else {
                        return DEFAULT_STATUS
                    }
                }
                return DEFAULT_STATUS
            },
            showExportFileDownloadLink(file) {
                if (file) {
                    if (file.dateRunFinish) {
                        return true
                    }
                }
                return false
            },
            formatNumber(val) {
                if (isNaN(val))
                    return 0.00

                return (Math.round(val * 100) / 100).toFixed(2)
            },
            localeString(val) {
                var dte = new Date(val)
                if (typeof dte.getMonth === 'function' && !isNaN(dte.getMonth()))
                    return dte.toLocaleString('en-GB', { timeZone: 'Europe/London' })

                return null
            },
            localeDateString(val) {
                var dte = new Date(val)
                if (typeof dte.getMonth === 'function' && !isNaN(dte.getMonth()))
                    return dte.toLocaleDateString('en-GB')

                return null
            },
            async handleExportClick(id, filename) {
                if (id && !isNaN(id) && id > 0) {

                    try {
                        let csvRows = await this.getExportRows(id)
                        if (csvRows) {
                            //console.log('-r: ', csvRows)
                            let csvCols = [
                                { key: 'claimReference', display: 'ClaimReference' },
                                { key: 'relatedReference', display: 'RelatedReference' },
                                { key: 'underwriter', display: 'Underwriter' },
                                { key: 'reseller', display: 'Reseller' },
                                { key: 'product', display: 'Product' },
                                { key: 'gadget', display: 'Gadget' },
                                { key: 'imeiSerialNo', display: 'IMEISerialNo' },
                                { key: 'gadgetValue', display: 'GadgetValue' },
                                { key: 'sal', display: 'SAL' },
                                { key: 'coverLimit', display: 'CoverLimit' },
                                { key: 'excess', display: 'Excess' },
                                { key: 'excessWaived', display: 'ExcessWaived' },
                                { key: 'excessPayment', display: 'ExcessPayment' },
                                { key: 'claimPaymentAmount', display: 'ClaimPaymentAmount' },
                                { key: 'policyCoverStartDate', display: 'PolicyCoverStartDate' },
                                { key: 'gadgetCoverStartDate', display: 'GadgetCoverStartDate' },
                                { key: 'incidentDate', display: 'IncidentDate' },
                                { key: 'pipelineResult', display: 'PipelineResult' },
                                { key: 'claimantName', display: 'ClaimantName' },
                                { key: 'accountName', display: 'AccountName' },
                                { key: 'accountNumber', display: 'AccountNumber' },
                                { key: 'sortcode', display: 'Sortcode' },
                                { key: 'amountToPay', display: 'AmountToPay' },];

                            let csvContent = new Blob([this.getCSV(csvCols, csvRows)])
                            const link = document.createElement("a")
                            link.href = window.URL.createObjectURL(csvContent, { type: "text/plain" })
                            link.download = filename ? filename + ".csv" : 'export.csv'
                            link.click()
                        }
                    } catch (err) {
                        console.error(err)
                    }
                }

            },
            getCSV(cols,items) {
                let csvData = []
                cols.forEach(c => {
                    csvData.push(c.display)
                    csvData.push(',')
                })
                csvData.pop()
                csvData.push("\r\n")

                items.map(item => {
                    cols.forEach(c => {
                        let escapedCSV = '=\"' + item[c.key] + '\"'
                        if (escapedCSV.match(/[,"\n]/)) {
                            escapedCSV = '"' + escapedCSV.replace(/\"/g, '""') + '"'
                        }
                        csvData.push(escapedCSV)
                        csvData.push(",")
                    })
                    csvData.pop()
                    csvData.push("\r\n")
                })

                csvData.pop()
                csvData.push("\r\n")
                return csvData.join("")
            },
            isItemDisabled(itm) {
                if (itm && itm.customerPaymentStatusId == 1002) {
                    return true
                }
                return false
            },
            getCoverLimit(itm) {
                if (itm) {
                    if (itm.hasOwnProperty("policyRatingTypeId") &&
                        itm.hasOwnProperty("policySAL") &&
                        itm.hasOwnProperty("policyCoverLimit") &&
                        itm.hasOwnProperty("gadgetValue")) {
                        if (itm["policyRatingTypeId"] == 1) {
                            return itm["gadgetValue"]
                        } else if (itm["policyRatingTypeId"] == 2) {
                            return itm["policySAL"]
                        } else {
                            return itm["policyCoverLimit"]
                        }
                    }
                } else {
                    return null;
                }
            }
        },
        beforeDestroy() {
            for (var prop in this.childWindows) {
                try {
                    this.childWindows[prop].close()
                } catch(err) { console.log(err) }
            }
            window.clearInterval(this.exportFileTimerId)
        }
    }
</script>

<style>
    .arrow {
        border: solid black;
        border-width: 0 2px 2px 0;
        display: inline-block;
        padding: 2px;
    }

    .right {
        transform: rotate(-45deg);
        -webkit-transform: rotate(-45deg);
    }

    .left {
        transform: rotate(135deg);
        -webkit-transform: rotate(135deg);
    }

    .up {
        transform: rotate(-135deg);
        -webkit-transform: rotate(-135deg);
    }

    .down {
        transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
    }

    .pointer {
        cursor: pointer;
    }

    .scroller {
        overflow: scroll;
        padding: 5px;
    }

    .scroller-x {
        overflow-x: scroll
    }

    .scroller-y {
        overflow-y: scroll
    }

    /* Removes the min-width on the dropdown-menu and sets the width to 100% of the parent */
    .wrap-dropdown {
        width: 100%;
        min-width: 0;
    }

        /* applies white-space: normal to all tags inside the dropdown-menu */
        .wrap-dropdown * {
            white-space: normal;
        }
</style>
